export const FREE = 'free';



// WEBPACK FOOTER //
// ./app/constants/consumerTypes.js